import { html, nothing, render } from "lit-html";
import { classificationTemplate } from "./Classification";
import { criteriaTemplate } from "./Criteria";

customElements.define(
	"esc-hotel-list-hotel-description-mobile",
	class extends HTMLElement {
		connectedCallback() {
			const template = html`<div class="hotel-list-item-mobile__description">
				${this.renderClassification()}
				<span class="hotel-list-item-mobile__location-name ellipsis"
					><i class="fa fa-map-marker"></i>${this.locationName}</span
				>
				<div class="hotel-list-item-mobile__name-container">
					<span class="ellipsis">${this.hotel.name}</span>
					<span class="fa fa-angle-right fa--space-before"></span>
				</div>
				${this.renderCriteria()}
			</div>`;
			render(template, this, { host: this });
		}

		renderClassification() {
			return this.hotel.classification
				? classificationTemplate(
						this.hotel.classification,
						this.hotel.classification_superior,
					)
				: nothing;
		}

		renderCriteria() {
			return this.hotel.important_criteria
				? criteriaTemplate(this.hotel.important_criteria)
				: nothing;
		}

		get locationName() {
			return this.hotel.location_name;
		}
	},
);
